import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import ACTIONS from '../store/action';

/**
 * OAuth return route — completes provider callback then redirects via redirectTo (Connections).
 */
const ConnectionOAuthReturn = ({ provider = 'xero', completeCallback }) => {
  useEffect(() => {
    completeCallback();
  }, [completeCallback]);

  return (
    <div className='flex min-h-[40vh] items-center justify-center p-6 text-muted-foreground'>
      Completing {provider} connection…
    </div>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  completeCallback: () =>
    dispatch(ownProps.provider === 'sage' ? ACTIONS.sageCallBack() : ACTIONS.xeroCallback()),
});

export default connect(null, mapDispatchToProps)(ConnectionOAuthReturn);
